import React, { useEffect, useState, useRef, useCallback, act } from "react";
import Grid from "./Grid";
import MobileControls from "./MobileControls";
import Winner from "./Winner";


import {
  useStoredBoxContent,
  useStoredHistory,
  useStoredStyleHistory,
} from "../customHooks/useStoredState";

function Game({ gameState, newGame, moves, setMoves, setUndoCount, hasWon, setHasWon, setOnHighscoreBoard}) {
  const intitialBoxContent = [
    [
      { value: "1", colour: "#b71234" },
      { value: "2", colour: "#b71234" },
      { value: "3", colour: "#b71234" },
      { value: "4", colour: "#b71234" },
    ],
    [
      { value: "1", colour: "#0046ad" },
      { value: "2", colour: "#0046ad" },
      { value: "3", colour: "#0046ad" },
      { value: "4", colour: "#0046ad" },
    ],
    [
      { value: "1", colour: "#009b48" },
      { value: "2", colour: "#009b48" },
      { value: "3", colour: "#009b48" },
      { value: "4", colour: "#009b48" },
    ],
    [
      { value: "1", colour: "#ffd500" },
      { value: "2", colour: "#ffd500" },
      { value: "3", colour: "#ffd500" },
      { value: "4", colour: "#ffd500" },
    ],
  ];
  // const verticleBoxContent = [
  //   [
  //     { value: "1", colour: "#b71234" },
  //     { value: "1", colour: "#0046ad" },
  //     { value: "1", colour: "#009b48" },
  //     { value: "1", colour: "#ffd500" },
  //   ],
  //   [
  //     { value: "2", colour: "#b71234" },
  //     { value: "2", colour: "#0046ad" },
  //     { value: "2", colour: "#009b48" },
  //     { value: "2", colour: "#ffd500" },
  //   ],
  //   [
  //     { value: "3", colour: "#b71234" },
  //     { value: "3", colour: "#0046ad" },
  //     { value: "3", colour: "#009b48" },
  //     { value: "3", colour: "#ffd500" },
  //   ],
  //   [
  //     { value: "4", colour: "#b71234" },
  //     { value: "4", colour: "#0046ad" },
  //     { value: "4", colour: "#009b48" },
  //     { value: "4", colour: "#ffd500" },
  //   ],
  // ];

  const [activeSquare, setActiveSquare] = useState([2, 2]);
  const [style, setStyle] = useState({
    swish: "",
    row: [],
    column: [],
  });
  const [styleHistory, setStyleHistory] = useStoredStyleHistory([]);
  const [boxContent, setBoxContent] = useStoredBoxContent(gameState); //gamestate
  const [history, setHistory] = useStoredHistory([gameState]); //gamestate
  const [rowCount, setRowCount] = useState([0, 0, 0, 0]);
  const prevNewGame = useRef(newGame);



  useEffect(() => {
    if (newGame && prevNewGame.current !== newGame) {
      setBoxContent(() => gameState); // gameState
      setHistory([gameState]);
      setOnHighscoreBoard(false);
      setMoves(0);
      setUndoCount(0);
      setStyle({ swish: "jumble", row: [0, 1, 2, 3], column: [0, 1, 2, 3] });
      setStyleHistory([]);
      // update rowcount so that row key changes every time.
      setRowCount((prevCount) => {
        const newRowCount = [...prevCount];
        for (let i = 0; i < newRowCount.length; i++) {
          newRowCount[i] += 1;
        }
        return newRowCount;
      });
    }
    // else {
    //   // reset count on very first render
    //   setRowCount([0, 0, 0, 0]);
    // }

    prevNewGame.current = newGame;
  }, [newGame, gameState]);

   function handleKeyDown(e) {
     // e.preventDefault();
     if(hasWon){
      return;
     }
     switch (e.key) {
       case "ArrowUp":
         e.preventDefault();
         handleUp();
         break;
       case "ArrowLeft":
         e.preventDefault();
         handleLeft();
         break;
       case "ArrowDown":
         e.preventDefault();
         handleDown();
         break;
       case "ArrowRight":
         e.preventDefault();
         handleRight();
         break;
       case " ":
        e.preventDefault();
         handleSpace();
         break;
       default:
         break;
     }
   }

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [activeSquare, boxContent, hasWon]);

   function handleUp(){
    const activeColumn = activeSquare[1];
    setBoxContent((prevState) => {
      const newContent = prevState.map((row) => [...row]);
      const temp = newContent[0][activeColumn];
      for (let i = 0; i < newContent.length - 1; i++) {
        newContent[i][activeColumn] = newContent[i + 1][activeColumn];
      }
      newContent[newContent.length - 1][activeColumn] = temp;
      return newContent;
    });
    const newMoves = moves + 1;
    setHistory((prevHistory) => [
      ...prevHistory.slice(0, newMoves),
      boxContent,
    ]);
    setStyleHistory((prevStyleHistory) => [
      ...prevStyleHistory.slice(0, moves),
      { swish: "down", row: [0, 1, 2, 3], column: [activeColumn] },
    ]);
    setMoves((prevMoves) => {
      const newMoves = prevMoves + 1;
      return newMoves;
    });
    setStyle({
      swish: "up",
      row: [0, 1, 2, 3],
      column: [activeColumn],
    });
  } 
    function handleLeft(){
    const activeRow = activeSquare[0];

    setBoxContent((prevState) => {
      const newContent = prevState.map((row) => [...row]);

      const temp = newContent[activeRow][0];
      for (let i = 0; i < newContent[activeRow].length - 1; i++) {
        newContent[activeRow][i] = newContent[activeRow][i + 1];
      }
      newContent[activeRow][newContent[activeRow].length - 1] = temp;
      return newContent;
    });
    const newMoves = moves + 1;
    setHistory((prevHistory) => [
      ...prevHistory.slice(0, newMoves),
      boxContent,
    ]);
    setStyleHistory((prevStyleHistory) => [
      ...prevStyleHistory.slice(0, newMoves),
      { swish: "right", row: [activeRow], column: [0, 1, 2, 3] },
    ]);
    setMoves((prevMoves) => {
      const newMoves = prevMoves + 1;
      return newMoves;
    });
    setStyle({
      swish: "left",
      row: [activeRow],
      column: [0, 1, 2, 3],
    });
    setRowCount((prevCount) => {
      const newRowCount = [...prevCount];
      newRowCount[activeRow] += 1;
      return newRowCount;
    });
  }

    function handleDown() {
    setActiveSquare((prevSquare) => {
      const newSquare = [...prevSquare];
      let newRow = newSquare[0] + 1;
      if (newSquare[0] === boxContent.length - 1) {
        newRow = 0;
      }
      newSquare[0] = newRow;
      return newSquare;
    });
  }

  function handleRight () {
    setActiveSquare((prevSquare) => {
      const newSquare = [...prevSquare];
      let newColIndex = newSquare[1] + 1;
      if (newSquare[1] === boxContent[0].length - 1) {
        newColIndex = 0;
      }
      newSquare[1] = newColIndex;
      return newSquare;
    });
  }

  function handleSpace() {
    if (moves > 0) {
      const prevMoves = moves - 1;
      setUndoCount((prevUndoCount) => prevUndoCount + 1);
      setBoxContent(history[moves]);
      console.log(styleHistory);
      console.log(styleHistory[moves - 1]);
       if (moves == styleHistory.length) {
        setStyleHistory((prevStyleHistory) => [
          ...prevStyleHistory.slice(0, prevMoves),
        ]);
        setStyle(() => styleHistory[moves - 1]);
       }
      
      setMoves((prevMoves) => prevMoves - 1);
    }
  }

  useEffect(() => {
    const won = checkWin();
    if (won) {
      setHasWon(true);
      setStyle({
        swish: "won",
        row: [0, 1, 2, 3],
        column: [0, 1, 2, 3],
      });
    } else {
      setHasWon(false);
    }
  }, [boxContent]);

  // const checkWin = useMemo(() => {
  //   return checkHorizontalWin() || checkVerticleWin();
  // });

  function checkWin() {
    return checkHorizontalWin() || checkVerticleWin();

    function checkHorizontalWin() {
      //const transposedContent = Array(4).fill(Array(4).fill(null));
      const transposedContent = new Array(4)
        .fill(null)
        .map(() => new Array(4).fill(null));
      for (let i = 0; i < boxContent.length; i++) {
        const row = boxContent[i];
        const colour = row[0].colour;

        for (let j = 0; j < row.length; j++) {
          const col = row[j];

          if (colour === col.colour) {
            transposedContent[j][i] = col.value;
          } else {
            return false;
          }
        }
      }
      return transposedContent.every((row) =>
        ["1", "2", "3", "4"].every((value) => row.includes(value))
      );
    }

    function checkVerticleWin() {
      const transposedContent = new Array(4)
        .fill(null)
        .map(() => new Array(4).fill(null));

      for (let i = 0; i < boxContent.length; i++) {
        const row = boxContent[i];
        const rowValueArray = row.map((cell) => cell.value);

        if (
          !["1", "2", "3", "4"].every((value) => rowValueArray.includes(value))
        ) {
          return false;
        }

        for (let j = 0; j < row.length; j++) {
          transposedContent[j][i] = row[j];
        }
      }
      return transposedContent.every((row) =>
        row.every((col) => col.colour === row[0].colour)
      );
    }
  }

  return (
    <>
      <div className="gameBox">
        <div className="winnerContainer" style={{ height: "" }}>
          {hasWon && <Winner />}
        </div>

        <Grid
          boxContent={boxContent}
          activeSquare={activeSquare}
          style={style}
          rowCount={rowCount}
        />
        <MobileControls
          handleDown={handleDown}
          handleLeft={handleLeft}
          handleUp={handleUp}
          handleRight={handleRight}
          handleSpace={handleSpace}
        />
      </div>
    </>
  );
}

export default Game;
